import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children, requireRole }) => {
  const { user, role, loading } = useAuth();
  const location = useLocation();

  if (loading) return <div className="min-h-screen flex items-center justify-center text-white">Loading…</div>;
  if (!user) {
    const from = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to="/login" replace state={{ from }} />;
  }
  
  // If a role is required but role hasn't loaded yet, show loading instead of redirecting
  if (requireRole && role === null) {
    return <div className="min-h-screen flex items-center justify-center text-white">Loading…</div>;
  }
  
  if (requireRole && role !== requireRole) return <Navigate to="/" replace />;
  return children;
};
